import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function ElementorBanner({ type = 'warning', children, }) {
    return (_jsx("div", { className: "elementor-control-content", children: _jsx("div", { className: `elementor-control-raw-html elementor-panel-alert elementor-panel-alert-${type}`, children: children }) }));
}
